<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M10.494 8.701a.994.994 0 000-1.41 1.003 1.003 0 00-1.414 0l-4.785 4.77a1 1 0 000 1.418l4.788 4.772c.39.39 1.024.39 1.415 0a.994.994 0 000-1.41l-3.086-3.075h13.92v.004a4.493 4.493 0 014.664 4.648H26v5.585a1 1 0 002 0v-5.585h-.002l.002-.166c0-3.578-2.91-6.479-6.5-6.479-.056 0-.112 0-.167.002v-.002H7.412l3.082-3.072z"/></svg>
</template>

<script>
export default {
  name: 'arrowsBendUpLeft'
}
</script>
